import UserDebug from "./-userDebug";
import { getSystemDefaultPath, isSuperAdminUser } from "@/stores/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/system/userDebug")({
  beforeLoad: () => {
    if (!isSuperAdminUser()) {
      throw redirect({ to: getSystemDefaultPath() });
    }
  },
  staticData: {
    menuLabel: "用户调试",
    showInMenu: true,
    menuGroup: "/system",
    menuOrder: 1,
    requireSuperAdmin: true,
  },
  component: UserDebug,
});
